import { render, staticRenderFns } from "./InvoiceItemsImportPage.vue?vue&type=template&id=5caf486c&scoped=true&"
import script from "./InvoiceItemsImportPage.vue?vue&type=script&lang=ts&"
export * from "./InvoiceItemsImportPage.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceItemsImportPage.vue?vue&type=style&index=0&id=5caf486c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caf486c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VSimpleTable,VSpacer})
